import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const Main = ({ children, ...props }) => {
  return (
    <Content className="pms-layout-main" {...props}>
      {children}
    </Content>
  );
};

export default Main;
